const reduceKeyToValue = objToReduce => Object.keys(objToReduce).reduce((obj, key) => {
  obj[objToReduce[key]] = key;
  return obj;
}, {});
export default reduceKeyToValue;